module.exports = __webpack_public_path__ + "img/cvv2.c2f59243.jpg";